<div class="content">
    <div>
        <button nz-button nzType="primary" nzDanger (click)="save()" [nzLoading]="saving"
            [disabled]="!dataChanged" style="float: right;">Save configuration</button>
    </div>
    <ag-grid-angular style="flex: 1"
        [theme]="theme"
        [rowData]="rowData" 
        [columnDefs]="colDefs"
        [defaultColDef]="defaultColDef"
        [sideBar]="sideBar"
        [gridOptions]="gridOptions"
        [loading]="gridLoading"
        (gridReady)="onGridReady($event)"
    />
</div>
